export default __webpack_public_path__ + "static/media/medical-history.9410b5a2.svg";